module.exports = __webpack_public_path__ + "static/img/bearish.e1e2379.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bearish.png
// module id = dgx8
// module chunks = 1